import { Label } from '@/components/ui/label'

interface PromptInputProps {
  value: string
  onChange: (v: string) => void
  label?: string
  placeholder?: string
  disabled?: boolean
}

export function PromptInput({ value, onChange, label, placeholder, disabled }: PromptInputProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label>{label ?? 'Prompt'}</Label>
      <textarea
        rows={16}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ?? 'Describe what you want to generate…'}
        disabled={disabled}
        className="w-full resize-y rounded-md border border-input bg-transparent px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
      />
    </div>
  )
}
